module.exports = __webpack_public_path__ + "static/media/myface.fb448a9d.png";